import "./About.scss";
import First from "../RandomNumbers/First";
import Second from "../RandomNumbers/Second";
import Third from "../RandomNumbers/Third";
import Fours from "../RandomNumbers/Fours";
import gumate from '../../image/production/granula.png'
import npkg from '../../image/production/npm-g.png'
import agrobolick from '../../image/production/agrobolick.png'
import tools from '../../image/production/about-image.png'
import npk from '../../image/production/NPK.png'
import logo from "../../image/logotype/logotype.svg";
import { Link } from "react-router-dom";
import logo1 from "../../image/logotype/logo.svg";


export default function About() {
    return (
        <div className="about__container">
            <div className="about__first-block">
                <div className="about__logo logo">
                    <img className="logo__photo" src={logo} alt="logo" />
                    <img className="logo__photo--mobile" src={logo1} alt="logo" />
                </div>
                <div className="about__information about">
                    <h1 className="about__header">САНБЕРРІ УКРАЇНА</h1>
                    <span className="about__header-text">Cанберрі Україна – від мрії до впевненості у високому врожаю</span>
                    <p className="about__header--paragraph">
                        Cанберрі Україна – це український виробник екологічних
                        органо-мінеральних добрив. Наші розробки є унікальними, базуються на
                        сучасних знаннях та враховують всі потреби вирощуваної культури.
                        Краще підтвердження ефективності мінеральних добрив від Sunberry
                        Ukraine – щорічне зростання обсягів виробництва та реалізації
                        власної продукції вже понад 12 років.
                    </p>
                    <p className="about__header--paragraph">
                        Секрет такого успіху – відповідальність. Ми виготовляємо комплексні добрива з високоякісних
                        імпортних складових та здійснюємо тестування власних розробок у
                        господарстві. З нашими NPK-комплексами можна вирощувати широкий
                        спектр культур – від зернових до плодово-овочевих.
                    </p>
                    <div className="quote">
                        <span className="quote-up">
                            «Наша головна мета - здійснити вашу мрію якісно, в потрібні
                            терміни та за доступною ціною.»
                        </span>
                        <span className="quote-down">
                            Захарчук Юрій - засновник Sunberry
                        </span>
                    </div>
                </div>
            </div>
            <div className="number">
                <First />
                <Second />
                <Third />
                <Fours />
            </div>
            <section className="product-section">
                <div className="product-section__container">
                    <div className="product-section__image">
                        <img src={tools} alt="Інструменти в ґрунті" />
                    </div>
                    <div className="product-section__content">
                        <h2 className="product-section__title">
                            Про нашу <span>продукцію</span>
                        </h2>
                        <p className="product-section__description">
                            Підкресліть потужність вашого врожаю з нашими добривами! Наші продукти допоможуть забезпечити ваші рослини всім необхідним для здорового росту та високих врожаїв. Оберіть найкращі добрива для вашого господарства від провідного виробника!
                        </p>
                        <div className="product-section__items">
                            <div className="product-item">
                                <Link to="/humateCard">
                                    <button className="product-item__icon">
                                        <img className="product__block--inside-icon" src={gumate} alt="" />
                                    </button>
                                </Link>
                                <div className="product-item__text">
                                    <h4>Гумати</h4>
                                    <p>Відновлювачі грунту</p>
                                </div>
                            </div>
                            <div className="product-item">
                                <Link to="/agroteinCard">
                                    <button className="product-item__icon">
                                        <img className="product__block--inside-icon" src={npkg} alt="" />
                                    </button>
                                </Link>
                                <div className="product-item__text">
                                    <h4>Гранульовані NPK</h4>
                                    <p>Мінеральні комплексні гранульовані добрива</p>
                                </div>
                            </div>
                            <div className="product-item">
                                <Link to="/agrobolikCard">
                                    <button className="product-item__icon">
                                        <img className="product__block--inside-icon" src={agrobolick} alt="" />
                                    </button>
                                </Link>
                                <div className="product-item__text">
                                    <h4>Агроболік</h4>
                                    <p>Добрива для позакореневого живлення</p>
                                </div>
                            </div>
                            <div className="product-item">
                                <Link to="/NPKCard">
                                    <button className="product-item__icon">
                                        <img className="product__block--inside-icon" src={npk} alt="" />
                                    </button>
                                </Link>
                                <div className="product-item__text">
                                    <h4>Рідкі NPK</h4>
                                    <p>Енергетичний комплекс для рослин</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div >
            </section >
        </div >
    );
}
